import React, { useState, useEffect } from 'react';
import { Tabs, Table } from 'antd';
import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import Paper from '@material-ui/core/Paper';

import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './SpecialtyScreenStyles';
import SpecialtyForm from 'app/components/SpecialtyForm';
import SpecialtyTableContainer from 'app/containers/SpecialtyTableContainer';
import { SpecialtyClear } from 'app/actions/SpecialtyActions';
import { useDispatch } from 'react-redux';

export default function SpecialtyScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [row, setRow] = useState({});

    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`  });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});
    const [filter, setFilter] = useState([]);
    const [idSpecialty, setIdSpecialty] = useState(0);
    const [visibleForm, isVisibleForm] = useState(false)
    const [nameSpecialty, setNameSpecialty] = useState('');
    const [trainingType, setTrainingType] = useState('');
    const [name, setName] = useState([]); //Filtro nombre de especialidad
    const [names, setNames] = useState([]); //Filtro Tipo de capacitación

    useEffect(() => {
        return () => {
            dispatch(SpecialtyClear());
        }
    }, []);

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isCatalog={true} header='Especialidad' isCommunicationStatus={false}/>
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                           Catálogos
                        </Link>
                        <TextEvents
                            text="Catálogo de Especialidades por Tipo de Capacitación"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Paper className={classes.rootPaper}>
                    <SpecialtyForm row={row} idSpecialty={idSpecialty} setIdSpecialty={setIdSpecialty} nameSpecialty={nameSpecialty} setNameSpecialty={setNameSpecialty} trainingType={trainingType} setTrainingType={setTrainingType} visibleForm={visibleForm} isVisibleForm={isVisibleForm}  filter={filter} setFilter={setFilter} pagination={pagination} sorter={sorter} formData={formData} setFormData={setFormData} name={name} setName={setName} names={names} setNames={setNames}/>
                    <div style={styles.baseVerticalMargin}>
                        <SpecialtyTableContainer setRow={setRow} setIdSpecialty={setIdSpecialty} setNameSpecialty={setNameSpecialty} isVisibleForm={isVisibleForm} classes={classes} filter={filter} sorter={sorter} setSorter={setSorter} pagination={pagination} setPagination={setPagination} formData={formData} name={name} setName={setName} names={names} setNames={setNames}>
                            {(params) => {
                                return (
                                    <div>
                                        <Table
                                            loading={params.isLoading}
                                            rowKey={item => String(item.idSpecialty)}
                                            columns={params.cols}
                                            dataSource={params.specialty}
                                            onChange={params.handleTableChange}
                                            pagination={pagination}
                                            //scroll={{ y: 700, x: "min-content" }}
                                            scroll={{ x: 'min-content', y: (height - 395) }}
                                            size={"small"}

                                        />
                                    </div>
                                )
                            }}
                        </SpecialtyTableContainer>
                    </div>
                </Paper>


                </div>
            </div>
         )
}